import { Dialog, DialogBody, DialogSurface } from "@fluentui/react-components";
import { useMfaSetup } from "./mfaSetup/useMfaSetup";

export function MfaSetup() {
  const { mfaSetupState, currentStep, steps, setMfaSetupState } = useMfaSetup();

  return (
    <Dialog
      open={mfaSetupState !== "closed"}
      onOpenChange={(_, data) =>
        setMfaSetupState((prev) => (data.open ? prev : "closed"))
      }
    >
      <DialogSurface>
        <DialogBody>
          {/*
            this is needed because otherwise there is no focusable element on mount of
            the dialog, and this makes the dynamically loaded content of the dialog
            inaccessible (i.e. not focusable)
          */}
          <button />
          {steps?.[currentStep]?.children}
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
